<template>
  <div 
    class="tip-container pulsating"
    @click.prevent="showTip"
  >
    <a 
      href="#" 
      class="tip" 
      :title="title"
    />
    <b-modal 
      v-model="showTipModal" 
      :title="title"
      :hide-footer="true"
      @hidden="showTipModal = false"
    >
        <slot />
        <hr>
        <div class="d-flex">
          <button 
            class="btn btn-dark"
            @click.prevent="showTipModal = false">
            <i class="fa fa-check mr-1" />
            Close Tip
          </button>
          <button class="ml-auto btn btn-white">
            Learn More
          </button>
        </div>
    </b-modal>
  </div>
</template>

<style lang="scss" scoped>
.tip-container {
  position: absolute;
  .tip {
    border: 8px solid #999;
    -webkit-border-radius: 30px;
    height: 30px;
    width: 30px;
    position: absolute;
  }
  &.pulsating {
    .tip {
      -webkit-animation: pulsate 1s ease-out;
      -webkit-animation-iteration-count: infinite; 
      opacity: 0.0;  
    }
  }
  &.default-position {
    top: -15px;
    right: 15px;
  }
}
@-webkit-keyframes pulsate {
  0% {-webkit-transform: scale(0.1, 0.1); opacity: 0.0;}
  50% {opacity: 1.0;}
  100% {-webkit-transform: scale(1.2, 1.2); opacity: 0.0;}
}
</style>

<script>
import $ from 'jquery'

export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    target: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      showTipModal: false
    }
  },
  mounted () {
    if (!this.target) {
      $(this.$el).addClass('default-position')
    }
  },
  methods: {
    showTip () {
      this.showTipModal = true
    }
  }
}
</script>
